function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "no_attachments",
  "data-name": "no attachments",
  transform: "translate(-322.25 -1360.001)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18558",
  "data-name": "Group 18558",
  transform: "translate(85.75 369.25)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_19708",
  "data-name": "Group 19708"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18020",
  "data-name": "Group 18020",
  transform: "translate(-562 468.751)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_2205",
  "data-name": "Line 2205",
  x2: 45.5,
  transform: "translate(857 523)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2207",
  "data-name": "Line 2207",
  x2: 13.5,
  transform: "translate(804.5 600.213)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2206",
  "data-name": "Line 2206",
  x2: 25.5,
  transform: "translate(857 534)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2208",
  "data-name": "Line 2208",
  x2: 25.5,
  transform: "translate(799 609.213)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_18017",
  "data-name": "Group 18017",
  transform: "translate(886.003 599.497)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518",
  "data-name": "Rectangle 7518",
  width: 2,
  height: 12,
  rx: 1,
  transform: "translate(5)",
  fill: "#cad4dd"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519",
  "data-name": "Rectangle 7519",
  width: 2,
  height: 12,
  rx: 1,
  transform: "translate(12 5) rotate(90)",
  fill: "#cad4dd"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_18018",
  "data-name": "Group 18018",
  transform: "translate(798.5 534)",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518-2",
  "data-name": "Rectangle 7518",
  width: 2,
  height: 12,
  rx: 1,
  transform: "translate(5)",
  fill: "#cad4dd"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519-2",
  "data-name": "Rectangle 7519",
  width: 2,
  height: 12,
  rx: 1,
  transform: "translate(12 5) rotate(90)",
  fill: "#cad4dd"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2885",
  "data-name": "Ellipse 2885",
  transform: "translate(849 620.497)",
  fill: "#fff",
  stroke: "#cad4dd",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 4.5,
  r: 4.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 4.5,
  r: 3.5,
  fill: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_18030",
  "data-name": "Group 18030",
  transform: "translate(-865.001 482)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18019",
  "data-name": "Group 18019",
  transform: "translate(302 -31)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18015",
  "data-name": "Group 18015",
  transform: "translate(825.001 558.6)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_17442",
  "data-name": "Group 17442",
  transform: "translate(-0.001 0.4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union_42",
  "data-name": "Union 42",
  d: "M29.5,59A29.509,29.509,0,0,1,18.019,2.318,29.509,29.509,0,0,1,40.984,56.684,29.312,29.312,0,0,1,29.5,59Zm0-56.642A27.14,27.14,0,1,0,56.642,29.5,27.171,27.171,0,0,0,29.5,2.361Z",
  transform: "translate(0 0)",
  fill: "#8c9cac"
}))))))), /*#__PURE__*/React.createElement("path", {
  id: "attachment",
  d: "M25.76,2.174a6.933,6.933,0,0,0-5.092-2.1,7.135,7.135,0,0,0-5.152,2.1L2.062,15.69a5.218,5.218,0,0,0,0,7.529,5.082,5.082,0,0,0,3.7,1.6,5.02,5.02,0,0,0,3.641-1.6L22.983,9.641A3.052,3.052,0,0,0,23.909,7.3a3.687,3.687,0,0,0-.926-2.407A3.2,3.2,0,0,0,20.638,3.9a2.818,2.818,0,0,0-2.222.987L5.888,17.417a1.157,1.157,0,0,0,0,1.851,1.114,1.114,0,0,0,1.851,0L20.082,6.741a.6.6,0,0,1,.926,0,.6.6,0,0,1,0,.926L7.616,21.243a2.536,2.536,0,0,1-3.7,0,2.536,2.536,0,0,1,0-3.7L17.305,4.026a4.562,4.562,0,0,1,3.333-1.419,4.362,4.362,0,0,1,3.27,1.419,4.422,4.422,0,0,1,1.358,3.24,4.628,4.628,0,0,1-1.358,3.3l-11.6,11.6a1.207,1.207,0,0,0,0,1.851,1.207,1.207,0,0,0,1.851,0l11.6-11.6a7.1,7.1,0,0,0,2.1-5.123,7.1,7.1,0,0,0-2.1-5.123Z",
  transform: "translate(362.792 1396.762)",
  fill: "#f3994e"
}));
function SvgNoAttachments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 107.497,
    viewBox: "0 0 104 107.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAttachments);
export default __webpack_public_path__ + "static/media/no-attachments.78967f94.svg";
export { ForwardRef as ReactComponent };